<template>
  <div class="flex w-full flex-col">
    <div class="flex flex-row">
      <div class="flex flex-1 flex-col">
        <div class="text-xl font-bold">{{ event.default_title }}</div>
        <div class="text-base font-semibold">
          {{ $h.rangeDateAsString(event.date_from, event.date_to) }}
        </div>
      </div>
    </div>
    <div class="flex flex-row">
      <div class="flex-1"></div>
      <div class="flex-1"></div>
    </div>
    <div class="flex flex-row">
      <div class="shrink-0">
        <EventUserSelector v-model:event="localEvent" />
      </div>
      <div class="flex-1"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import EventUserSelector from '@c/Event/EventUserSelector.vue'

export default defineComponent({
  name: 'EventCard',
  components: { EventUserSelector },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  emits: ['update:event'],
  computed: {
    localEvent: {
      get() {
        return this.event
      },
      set(value) {
        this.$emit('update:event', value)
      }
    }
  }
})
</script>

<style scoped></style>
